// @ts-strict-ignore
import { useMetaViewModel } from "@services/useMetaViewModel";

/**
 * A low-level hook for setting the developer in the view model. This should only be used to push changes out to the view model
 */
export const useDeveloperViewModel = () => {
  return useMetaViewModel("developer");
};
